import { Component, Input, ChangeDetectorRef } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../../order.service";
import { ActivePageEnum } from "../../model/activepage.enum";
import { CustomerOrderService } from "../../customerorder/customerorder.service";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
@Component({
  selector: "order-footer",
  templateUrl: "./orderfooter.component.html",
  styleUrls: ["./orderfooter.component.scss"],
})
export class OrderFooterComponent extends BaseListComponent {
  @Input() currentActivePage: ActivePageEnum;
  @Input() customerOrder: CustomerOrderService;
  activePageEnum: typeof ActivePageEnum = ActivePageEnum;
  constructor(public order: OrderService, public cd: ChangeDetectorRef, public common: CommonService) {
    super();
    this.NoLog = true;
    this.order.cd_Footer = this.cd;
  }

  showFastAccess($event) {
    this.order.hideFastAccess = !this.order.hideFastAccess;
  }
  setDestinationPage(): void {
    switch (this.order.currentSaleMethodNature) {
      case SaleMethodNature.FastFood:
        this.order.shouldActivateSalonPage = false;
        this.order.shouldActivateInvoicesPage = false;
        break;
      case SaleMethodNature.Delivery:
        this.order.shouldActivateSalonPage = false;
        this.order.shouldActivateInvoicesPage = false;
        break;
      case SaleMethodNature.Restaurant:
        this.order.shouldActivateSalonPage = true;
        this.order.shouldActivateInvoicesPage = false;
        break;
    }
  }
}
